import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Button, Col, ControlLabel, Form, FormControl, FormGroup, HelpBlock} from 'react-bootstrap';
import Select from 'react-select';

class UserForm extends React.Component {

  render() {
    return (
      <Form horizontal onSubmit={this.props.onSave} >
        <FormGroup validationState={this.props.errors && this.props.errors.first_name ? 'error' : null } controlId="formHorizontalFirstName">
          <Col xs={3} componentClass={ControlLabel}>
            First Name
          </Col>
          <Col xs={6}>
            <FormControl data-cy="createuser-fn" name="first_name" type="text" placeholder="First Name" value={this.props.preset.first_name} onChange={this.props.onChange}/>
            <FormControl.Feedback />
            { this.props.errors.first_name ? <HelpBlock>{this.props.errors.first_name}</HelpBlock> : '' }
          </Col>
        </FormGroup>
        <FormGroup validationState={this.props.errors && this.props.errors.last_name ? 'error' : null } controlId="formHorizontalLastName">
          <Col xs={3} componentClass={ControlLabel}>
            Last Name
          </Col>
          <Col xs={6}>
            <FormControl data-cy="createuser-ln" name="last_name" type="text" placeholder="Last Name" value={this.props.preset.last_name} onChange={this.props.onChange}/>
            <FormControl.Feedback />
            { this.props.errors.last_name ? <HelpBlock>{this.props.errors.last_name}</HelpBlock> : '' }
          </Col>
        </FormGroup>
        <FormGroup validationState={this.props.errors && this.props.errors.email ? 'error' : null } controlId="formHorizontalEmail">
          <Col xs={3} componentClass={ControlLabel}>
            Email
          </Col>
          <Col xs={6}>
            <FormControl disabled={!this.props.isCreating && !this.props.isInviting} data-cy="createuser-email" name="email" type="text" placeholder="Email" value={this.props.preset.email} onChange={this.props.onChange}/>
            <FormControl.Feedback />
            { this.props.errors.email ? <HelpBlock>{this.props.errors.email}</HelpBlock> : '' }
          </Col>
        </FormGroup>
        <br/><br/>
        {
          this.props.isCreating &&
            <Fragment>
              <FormGroup validationState={this.props.errors && this.props.errors.password ? 'error' : null } controlId="formHorizontalPassword">
                <Col xs={3} componentClass={ControlLabel}>
                  Password
                </Col>
                <Col xs={6}>
                  <FormControl data-cy="createuser-pwd" name="password" type="password" placeholder="Password" value={this.props.preset.password} onChange={this.props.onChange}/>
                  <FormControl.Feedback />
                  { this.props.errors.password ? <HelpBlock>{this.props.errors.password}</HelpBlock> : '' }
                </Col>
              </FormGroup>
              <FormGroup validationState={this.props.errors && this.props.errors.confirmPassword ? 'error' : null } controlId="formHorizontalConfirmPassword">
                <Col xs={3} componentClass={ControlLabel}>
                  Confirm Password
                </Col>
                <Col xs={6}>
                  <FormControl data-cy="createuser-confirm-pwd" name="confirmPassword" type="password" placeholder="Confirm Password" value={this.props.preset.confirmPassword} onChange={this.props.onChange}/>
                  <FormControl.Feedback />
                  { this.props.errors.confirmPassword ? <HelpBlock>{this.props.errors.confirmPassword}</HelpBlock> : '' }
                </Col>
              </FormGroup>
              <br/><br/>
            </Fragment>
        }
        <FormGroup data-cy={'createuser-formgroup-role'} validationState={this.props.errors && this.props.errors.role ? 'error' : null }>
          <Col xs={3} componentClass={ControlLabel}>
            User Role
          </Col>
          <Col xs={6}>
            <Select
              value={this.props.preset.role}
              options={[{ value: 'admin', label: 'Admin' }, { value: 'coach', label: 'Coach' }, { value: 'customer', label: 'Customer' }]}
              onChange={this.props.onChangeSelectRole}
            />
            { this.props.errors.role ? <HelpBlock>{this.props.errors.role}</HelpBlock> : '' }
          </Col>
        </FormGroup>
        <FormGroup>
          <Col xs={3} componentClass={ControlLabel}>
            Companies
          </Col>
          <Col xs={6}>
            <Select
              multi={true}
              value={this.props.preset.companies}
              isLoading={!this.props.optionsLoaded}
              options={this.props.companyOptions}
              onChange={this.props.onChangeSelectCompanies}
              disabled={!['customer', 'coach'].includes(this.props.preset.role)}
            />
          </Col>
        </FormGroup>

        <FormGroup>
            <Col xsOffset={3} xs={6}>
                <div className='text-right'>
                  <Button data-cy="cancel-user" onClick={this.props.onCancel}>Cancel</Button>

                  <Button
                      data-cy="save-user"
                      className='primary'
                      style={{ marginLeft: '15px' }}
                      type="submit"
                  >
                    { this.props.isInviting ? 'Send Invite' : 'Save User' }
                  </Button>
              </div>
            </Col>
        </FormGroup>

      </Form>
    );
  }
}

UserForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  onChangeSelectRole: PropTypes.func.isRequired,
  onChangeSelectCompanies: PropTypes.func.isRequired,
  preset: PropTypes.object,
  companyOptions: PropTypes.array,
  optionsLoaded: PropTypes.bool,
  onCancel: PropTypes.func,
  isCreating: PropTypes.bool,
  isInviting: PropTypes.bool,
  onSave: PropTypes.func
};

export default UserForm;


// WEBPACK FOOTER //
// ./src/components/user/UserForm.js